import { DIRECTIONS } from "./constants";

export const isUpDirection = (direction: DIRECTIONS) =>
  direction === DIRECTIONS.UP;
export const isDownDirection = (direction: DIRECTIONS) =>
  direction === DIRECTIONS.DOWN;
